import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./loves_sandbox_api_server.js";
//#region src/loves_sandbox_api_server_helper.ts
var loves_sandbox_api_server_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(apiServer) {
	switch (apiServer) {
		case "dev": return "Development";
		case "qa": return "QA";
	}
}
//#endregion
export { loves_sandbox_api_server_helper_exports, name };

//# sourceMappingURL=loves_sandbox_api_server_helper.js.map